import { useState } from 'react';

export function useFilters(defaults = {}) {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(defaults.limit || 25);
  const [sortField, setSortField] = useState(defaults.sortField || '');
  const [sortDir, setSortDir] = useState(defaults.sortDir || 'asc');
  const [filters, setFilters] = useState(defaults.filters || {});

  const toggleSort = (field) => {
    if (sortField === field) {
      setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDir('asc');
    }
    setPage(1);
  };

  const setFilter = (key, value) => {
    setFilters(f => ({ ...f, [key]: value }));
    setPage(1);
  };

  const resetFilters = () => {
    setSearch('');
    setPage(1);
    setFilters(defaults.filters || {});
    setSortField(defaults.sortField || '');
    setSortDir(defaults.sortDir || 'asc');
  };

  const handleSearch = (val) => {
    setSearch(val);
    setPage(1);
  };

  const buildQuery = (extra = {}) => {
    const params = new URLSearchParams();
    if (search) params.set('q', search);
    params.set('page', page);
    params.set('limit', limit);
    if (sortField) { params.set('sort', sortField); params.set('order', sortDir); }
    Object.entries(filters).forEach(([k, v]) => { if (v) params.set(k, v); });
    Object.entries(extra).forEach(([k, v]) => { if (v) params.set(k, v); });
    return params.toString();
  };

  return { search, setSearch: handleSearch, page, setPage, limit, setLimit, sortField, sortDir, toggleSort, filters, setFilter, resetFilters, buildQuery };
}
